import type { SgApplicationConfiguration } from './types';

const EXTERNAL_APP_DETECT_REGEXP = new RegExp(`^(?:#/|#|/)(sg-external)(?:/|\\?|().*)?$`);

const APP_BASE_SUBDOMAIN = 'specials';
const HOSTNAME_DETECT_REGEXP = new RegExp(`^${APP_BASE_SUBDOMAIN}(?:-.*)?\\.sharegain\\.com$`);

declare module '@sg/pre-app-init/src/lib/application' {
  export interface SgCustomAppBranding {
    'sg-external': {
      logoMainPage: string;
    };
  }
}

export const sgExternal: SgApplicationConfiguration<'sg-external'> = {
  name: 'sg-external',
  authType: 'noAuth',
  branding: {
    css: ['sg-default-theme', 'sg-external-theme'],
    theme: 'dark',
    hideSideNav: true,
    hideTopBar: true,
    favIcon: 'assets/images/favicon/favicon.ico',
    custom: {
      logoMainPage: 'assets/images/white-sharegain-logo.svg',
    },
  },
  brandingMap: {},
  matcher: (location: Location) => {
    return (
      EXTERNAL_APP_DETECT_REGEXP.test(location.pathname) ||
      EXTERNAL_APP_DETECT_REGEXP.test(location.hash) ||
      HOSTNAME_DETECT_REGEXP.test(location.hostname)
    );
  },
};
